<div class="compare-tab">
  <div class="search-row">
    <span class="material-symbols-outlined search-icon">search</span>
    <input
      type="text"
      class="search-input"
      [placeholder]="'Search nodes...' | translate"
      (input)="onSearch($any($event.target).value)">
    </div>

    <div class="tree-scroll">
      @for (group of filteredGroups; track trackByKey($index, group)) {
        <div class="tree-group">
          <div class="tree-group-header" (click)="toggleGroup(group.key)">
            <span class="material-symbols-outlined expand-icon">
              {{ expandedGroups.has(group.key) ? 'expand_more' : 'chevron_right' }}
            </span>
            <span class="group-name">{{ group.key }}</span>
            <span class="group-count">{{ group.items.length }}</span>
          </div>
          @if (expandedGroups.has(group.key)) {
            <div class="tree-group-body">
              @for (ep of group.items; track trackByIndex($index)) {
                <label
                  class="tree-node"
                  [class.selected]="isSelected(ep.id)"
                  [class.locked]="ep.id === lockedEndpointId">
                  <input
                    type="checkbox"
                    [checked]="isSelected(ep.id)"
                    [disabled]="ep.id === lockedEndpointId || (!isSelected(ep.id) && isAtNodeLimit())"
                    (change)="onToggle(ep, $any($event.target).checked)">
                    <span class="node-name">{{ ep.name }}</span>
                    @if (ep.id === lockedEndpointId) {
                      <span class="lock-icon material-symbols-outlined" title="{{ 'Current node' | translate }}">lock</span>
                    }
                  </label>
                }
              </div>
            }
          </div>
        }

        @if (filteredGroups.length === 0) {
          <div class="empty-search">
            {{ 'No nodes found' | translate }}
          </div>
        }
      </div>

      <div class="compare-footer">
        <div class="counter-row">
          <span class="counter-badge" [class.at-limit]="nodeCount >= 5">
            {{ nodeCount }} / 5 {{ 'nodes' | translate }}
          </span>
        </div>
        <div class="footer-actions">
          <button class="btn btn-secondary btn-sm" (click)="clearAll.emit()" [disabled]="selectedEndPoints.length === 0">
            {{ 'Clear All' | translate }}
          </button>
          <button class="btn btn-primary btn-sm" (click)="apply.emit()" [disabled]="selectedEndPoints.length === 0">
            {{ 'Apply' | translate }}
          </button>
        </div>
      </div>
    </div>
